<template>
    <div>
        <navbar/>
        <div class="frame">
            <div class="container version-widget">
                <h4>MVP</h4>
                <h3 class="version" style="display: inline" v-for="(version, index) in versions" :key="index"><router-link :to="'?version=' + version">{{version}}</router-link></h3>
            </div>
        <div class="sketch">
            <div class="inline" v-for="(block, index) in blocks" :key="index" >
                <router-link :to="'?cat='+block.name" class="block inline">{{block.name}} <a>0{{getCompletedTasks(block).length}}/{{parseInt(block.tasks.length)}}</a></router-link>
                
            </div>
            <div class="description">
                Todos:
                <div v-for="(task, index) in getTodo()" :key="index">
                    <a>{{task.title}}</a>      
                </div>

                
               
              
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import navbar from '../../navbar.vue'
export default {
    components: {
        navbar,
    },
    name: 'Project',
    data(){
        return {
            tasks: [
                
            ],
            blocks: [
                {
                    name: "Routing",
                    tasks: [
                        {
                            title: 'Create Builder page route',
                            version: '0.1',
                            status: 'pending',
                            description: 'descr'
                        },
                        {
                            title: 'Create Users page route',
                            version: '0.2',
                            status: 'pending',
                            description: ''
                        },
                    ]
                },
                {
                    name: "Pages",
                    tasks: [
                        {
                            title: 'Task 1',
                            version: '0.1',
                            status: 'done',
                            description: ''
                        },
                        {
                            title: 'Task 2',
                            version: '0.2',
                            status: 'done',
                            description: ''
                        },
                    ]
                },
                {
                    name: "Reusables",
                    tasks: [
                        {
                            title: 'Task 1',
                            version: '0.1',
                            status: 'done',
                            description: ''
                        },
                        {
                            title: 'Task 2',
                            version: '0.2',
                            status: 'done',
                            description: ''
                        },
                    ]
                },
                {
                    name: "Widgets",
                    tasks: [
                        {
                            title: 'Task 1',
                            version: '0.1',
                            status: 'done',
                            description: ''
                        },
                        {
                            title: 'Task 2',
                            version: '0.2',
                            status: 'done',
                            description: ''
                        },
                    ]
                },
                {
                    name: "Vuex State",
                    tasks: [
                        {
                            title: 'Task 1',
                            version: '0.1',
                            status: 'done',
                            description: ''
                        },
                        {
                            title: 'Task 2',
                            version: '0.2',
                            status: 'done',
                            description: ''
                        },
                    ]
                },
            ],
            leftArrow: '<',
            rightArrow: '>',
            versions: [
                "Builder",
                "0.2",
                "0.3",
                "0.4",
                "0.5",
            ]
        }
    },
    methods: {
        getCompletedTasks(block){
            var completedTasks = []
            block.tasks.forEach(task => {
                if(task.status == 'done'){
                    completedTasks.push(task)
                }
            });
            return completedTasks
        },
        getTodo(){
            var arr = []
            for (let i = 0; i< this.blocks.length; i++){
                if (this.$route.query.cat == this.blocks[i].name){
                    for(let j=0; j< this.blocks[i].tasks.length; j++){
                        arr.push(this.blocks[i].tasks[j])
                    }
                        
                return arr
                }
            }
           
        }
    }
}
</script>

<style scoped>

.frame{
    border: 1px solid #9198aa;
    margin: 5%;
    text-align: center !important;
    padding: 5%;
}
.version-widget {
    display: inline-block;
}
.version-widget h1 {
  display: inline;
}
.version-widget .arrow {
    font-size: 50px;
}
.version-widget .arrow:hover{
 
    cursor: pointer;
}
.version {
    cursor: pointer;
    margin: 15px;
}
.block {
    vertical-align: top;
    margin: 25px;
    width: 75px;
  
    height: 75px;
    border: 1px solid #B2B3B4;
    border-radius: 6px;
    padding: 5px;
}
.block:hover{
    border: 1px solid #1997c6;
}
.inline {
    display: inline-block;
}
</style>